export const getEmptyDataText = t => ({
  emptyVacancies: {
    title: t('empty.vacancies.title'),
    description: t('empty.vacancies.description'),
  },
  emptyInternships: {
    title: t('empty.internships.title'),
    description: t('empty.internships.description'),
  },
  emptyCategory: {
    title: t('empty.category.title'),
    description: t('empty.category.description'),
  },
  emptyCompanies: {
    title: t('empty.companies.title'),
    description: t('empty.companies.description'),
  },
});
